<div class="flex items-center justify-between gap-4 w-[100%]" [class.flex-row-reverse]="caretLeft">
  <div class="flex-grow">
    <ng-content></ng-content>
  </div>

  <div class="text-neutral-30 text-xl icon-transition" [class.rotate-180]="open">
    <i class="fa-light fa-chevron-down"></i>
  </div>
</div>
